<template>
    <span class="has-text-weight-medium">
        <slot />
    </span>
</template>